export enum ReasonTypes {
  RefusalInInforming = 'RefusalInInforming',
  NotIdentified = 'NotIdentified',
}

export interface SortedActive {
  date: null | string;
}
